<template>
    <div
        class="dropdown"
        v-if="true == editable"
    >
        <div class="d-flex align-items-center">
            <template v-if="value">
                <img
                    v-if="value.image"
                    :src="value.image"
                />
                <span> {{ value ? value.name : '' }}</span>
            </template>

            <a
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn btn-add"
                @click="showDropdown = !showDropdown"
                ><i class="icon-edit"></i
            ></a>
        </div>

        <div
            v-if="showDropdown"
            aria-labelledby="dropdownAddProduct"
            class="dropdown-menu quick-search"
            style="display: block"
            v-click-outside="hidePopup"
        >
            <div class="searchbar">
                <a
                    href=""
                    class="btn-search"
                    ><i class="icon-search"></i
                ></a>
                <input
                    type="text"
                    placeholder="Quick Search"
                    class="search-input dropdown"
                    v-on:keyup="searchProduct"
                    v-on:keyup.enter="searchProduct"
                    v-model="search"
                />
                <button
                    class="btn-reset"
                    @click="search = ''"
                >
                    <i class="icon-close"></i>
                </button>
            </div>

            <div
                class="popup-trigger"
                v-if="search.length < 3"
            >
                <div class="quick-search-group">
                    <span
                        class="dropdown-item trigger-products"
                        data-toggle="modal"
                        data-target="#modal-add-new-product"
                        @click="showModal = true"
                    >
                        <i class="icon-inventory"></i>
                        <span>Product</span>
                    </span>
                    <span
                        class="dropdown-item"
                        @click="removeProduct"
                    >
                        <i class="icon-arclight icon-deleteforever remove"></i>
                        <span>Remove Product</span>
                    </span>
                </div>
            </div>

            <!-- search by textbox -->
            <div
                class="search-result"
                style="display: block"
                v-else
            >
                <div
                    class="quick-search-group"
                    v-if="searchResult.length"
                >
                    <div class="result-title">Product</div>
                    <span
                        v-for="result in searchResult"
                        class="dropdown-item trigger-products"
                        data-toggle="modal"
                        data-target="#modal-add-new-product"
                        :key="result.sku"
                        @click="selectProduct(result)"
                    >
                        <span>{{ result.product.name }}</span>
                    </span>
                </div>
            </div>
        </div>

        <!--  search modal -->
        <div
            class="modal-backdrop fade show"
            v-if="showModal"
        ></div>
        <div
            class="modal bo-modal fade show"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-add-new-product"
            aria-hidden="true"
            v-if="showModal"
            style="display: block"
        >
            <div
                class="modal-dialog modal-dialog-centered"
                role="document"
                style="max-width: 90%"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">Assign Product</div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="showModal = false"
                        >
                            <i class="icon-close"></i>
                        </button>
                    </div>

                    <div class="modal-body">
                        <!-- TAB NAV -->
                        <ul
                            class="nav nav-tabs bo-nav"
                            id="tab-add-products"
                            role="tablist"
                        >
                            <!-- NAV - PRODUCTS -->
                            <li class="nav-item">
                                <a
                                    :class="['nav-link active']"
                                    id="tab-products"
                                    data-toggle="tab"
                                    href="#products"
                                    role="tab"
                                    aria-controls="products"
                                    aria-selected="true"
                                >
                                    <span>Products</span>
                                    <span class="badge">{{ totalProducts }}</span>
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content tab-content-add-products">
                            <div
                                class="tab-pane fade show active"
                                id="all-products"
                                role="tabpanel"
                                aria-labelledby="tab-all-products"
                            >
                                <bo-datatable
                                    ref="assignProductTable"
                                    :select-single-record="selectSingleProduct"
                                    :columns="columns"
                                    :get-records-url="getProductUrl"
                                    :get-select-options-url="getProductOptionsUrl"
                                    :without-product-advance-search="withoutProductAdvanceSearch"
                                    @hook:mounted="initialWatcher"
                                ></bo-datatable>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer d-flex justify-content-between">
                        <div class="selections">
                            <div class="total-selected"></div>
                        </div>
                        <div class="buttons">
                            <button
                                type="button"
                                class="btn btn-rounded light"
                                data-dismiss="modal"
                                @click="showModal = false"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="btn btn-rounded arclight"
                                data-dismiss="modal"
                                :disabled="tempSelectedProduct == ''"
                                @click="addProducts"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- need to further work on selectSingleRecord -->
    <div
        v-else
        class="d-flex align-items-center"
    >
        <img
            v-if="value.image"
            :src="value.image"
        />
        <span> {{ value ? value.name : '' }}</span>
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

export default {
    props: ["columns", "editable", "id", "getProductUrl", "getProductOptionsUrl", "parentId", "updatePath", "value"],

    data() {
        return {
            totalProducts: 0,
            showModal: false,
            selectSingleProduct: true,
            withoutProductAdvanceSearch: true,
            tempSelectedProduct: "",
            selectedProduct: "",
            showDropdown: false,
            search: "",
            searchResult: [],
        };
    },

    methods: {
        initialWatcher() {
            this.$watch("$refs.assignProductTable.tableFooter.total", (new_value, old_value) => {
                this.totalProducts = new_value;
            });

            this.$watch("$refs.assignProductTable.selectedRow", (new_value, old_value) => {
                this.tempSelectedProduct = new_value;
            });
        },

        addProducts() {
            var selectedProducts = this.$refs.assignProductTable.records.filter((record) => {
                return this.tempSelectedProduct == record[this.$refs.assignProductTable.primaryKey];
            });
            var product_value = selectedProducts[0];
            product_value.image = product_value.product.image;
            product_value.name = product_value.product.name;
            Vue.delete(product_value, "product");

            this.showDropdown = false;
            this.showModal = false;

            this.$emit("change", product_value);
        },

        selectProduct(result) {
            var product_value = result;
            product_value.image = product_value.product.image;
            product_value.name = product_value.product.name;
            Vue.delete(product_value, "product");

            this.showDropdown = false;
            this.$emit("change", product_value);
        },

        hidePopup() {
            this.showDropdown = 0;
        },

        searchProduct(event) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                if (3 <= this.search.length) {
                    document.body.classList.add("loading");
                    axios({
                        url: this.getProductUrl,
                        method: "GET",
                        params: {
                            search: "product_name~~~" + this.search,
                        },
                    })
                        .then((response) => {
                            var self = this;
                            this.searchResult = response.data.data;
                        })
                        .catch(function (error) {
                            alert("Unable to load products now.");
                        })
                        .then(function () {
                            document.body.classList.remove("loading");
                        });
                }
            }, 500);
        },

        removeProduct() {
            var product_value = null;
            this.$emit("change", product_value);
        },
    },
};
</script>
